// « Ma journée » : DEUX grandeurs distinctes sur une carte, à ne jamais confondre.
//  - le temps prévu CE JOUR (celui de l'affectation : une demi-journée = 3,5 h, par exemple) ;
//  - le temps des ÉTAPES listées (temps prévu de chaque étape, qui peut couvrir plusieurs jours quand la carte montre tout le poste).
// Somme exacte en centièmes d'heure (jamais d'arrondi flottant) ; une étape sans temps prévu est comptée à part, jamais comme 0 h.
import { nombre, pluriel } from '../../../lib/format.ts';

/** Centièmes d'heure d'une chaîne décimale (« 3.5 », « 2,25 ») ; null si illisible. */
const centiemes = (h: string): number | null => {
  const m = /^\s*(\d+)(?:[.,](\d{1,2}))?\d*\s*$/.exec(h);
  return m ? Number(m[1]) * 100 + Number((m[2] ?? '0').padEnd(2, '0')) : null;
};

/** Total des heures prévues des étapes (centièmes) et nombre d'étapes sans temps prévu. */
export function tempsDesEtapes(etapes: { hours_planned: string | null }[]) {
  let total = 0; let sansTemps = 0;
  for (const e of etapes) {
    const c = e.hours_planned === null ? null : centiemes(e.hours_planned);
    if (c === null) sansTemps++; else total += c;
  }
  return { heures: total / 100, sansTemps };
}

/**
 * Phrase sous la liste des étapes d'une carte : le temps des étapes, et s'il dépasse le temps prévu ce jour, ce que cela veut dire.
 * null : aucune étape listée.
 */
export function resumeTempsCarte(heuresJour: string | null, etapes: { hours_planned: string | null }[], choisies: boolean): string | null {
  if (!etapes.length) return null;
  const { heures, sansTemps } = tempsDesEtapes(etapes);
  const sans = pluriel(sansTemps, 'étape sans temps prévu', 'étapes sans temps prévu');
  const total = sansTemps === etapes.length ? sans : `${nombre(heures, 2)} h${sansTemps ? ` + ${sans}` : ''}`;
  const jour = heuresJour === null ? null : centiemes(heuresJour);
  const depasse = jour !== null && Math.round(heures * 100) > jour;
  if (choisies) {
    return `Étapes choisies pour ce jour : ${total}${depasse ? ` — plus que le temps prévu ce jour (${nombre(heuresJour!, 2)} h), à voir avec le responsable` : ''}.`;
  }
  return `Toutes les étapes du poste : ${total}${depasse ? ` — plus que le temps prévu ce jour (${nombre(heuresJour!, 2)} h) : tout n’est pas à faire ce jour-là` : ''}.`;
}
